<div class="pantallaCarga">
  <div class="d-flex pez">
    <img src="../../../../../assets/images/whale8.svg" alt="Descripción del SVG" class="ballena" />

    <!-- <svg
      fill="#000000"
      height="3.1rem"
      width="12rem"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512 512"
      xml:space="preserve"
    >
      <g>
        <g>
          <path
            d="M376.487,156.872c-7.824-2.621-15.81-4.798-23.911-6.558c-11.362-35.804-44.725-60.763-83.22-60.763
			c-9.024,0-16.34,7.316-16.34,16.34v45.237c-61.866,14.491-114.693,54.448-145.689,109.979l-82.815-47.813
			C13.642,207.017,0,214.87,0,227.444v112.832c0,12.656,13.707,20.39,24.511,14.151l82.771-47.788
			c54.86,99.108,169.471,136.996,269.266,104.375C347.091,328.881,347.035,239.115,376.487,156.872z M283.501,295.317
			c9.024,0,16.34,7.316,16.34,16.34c0,9.024-7.316,16.34-16.34,16.34c-39.666,0-71.937-32.27-71.937-71.936
			c0-9.024,7.316-16.34,16.34-16.34h55.597c9.024,0,16.34,7.316,16.34,16.34c0,9.024-7.316,16.34-16.34,16.34h-35.692
			C254.021,285.914,267.683,295.317,283.501,295.317z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M510.509,277.039c-21.967-47.818-59.157-85.032-103.819-107.565c-26.49,75.125-25.772,155.966,0.133,229.154
			c46.968-23.355,82.422-61.656,103.688-107.948C512.497,286.351,512.497,281.369,510.509,277.039z M440.122,273.829
			c-11.938,0-21.616-9.678-21.616-21.616c0-11.938,9.678-21.616,21.616-21.616s21.616,9.678,21.616,21.616
			C461.738,264.151,452.06,273.829,440.122,273.829z"
          />
        </g>
      </g>
    </svg> -->
  </div>

  <div class="d-flex splash">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      width="20rem"
      height="15rem"
      viewBox="0 0 2000 2000"
      xml:space="preserve"
    >
      <desc>Created with Fabric.js 5.2.4</desc>
      <defs></defs>
      <g transform="matrix(1 0 0 1 540 540)" id="c8bd14b6-2a85-4f2d-be2c-32da949c6043">
        <rect
          style="
            stroke: none;
            stroke-width: 1;
            stroke-dasharray: none;
            stroke-linecap: butt;
            stroke-dashoffset: 0;
            stroke-linejoin: miter;
            stroke-miterlimit: 4;
            fill: rgb(255, 255, 255);
            fill-rule: nonzero;
            opacity: 1;
            visibility: hidden;
          "
          vector-effect="non-scaling-stroke"
          x="-540"
          y="-540"
          rx="0"
          ry="0"
          width="1080"
          height="1080"
        />
      </g>
      <g transform="matrix(1 0 0 1 540 540)" id="72ee70b0-a9fa-44a7-a2fa-800c006ad4d4"></g>
      <g transform="matrix(1.89 0 0 0.79 556.45 472.54)" id="4f078430-2cc6-46ba-a410-341f4d772d79">
        <path
          style="
            stroke: #1a6fc9;
            stroke-width: 0;
            stroke-dasharray: none;
            stroke-linecap: butt;
            stroke-dashoffset: 0;
            stroke-linejoin: miter;
            stroke-miterlimit: 4;
            fill: #1a6fc9;
            fill-rule: nonzero;
            opacity: 1;
          "
          vector-effect="non-scaling-stroke"
          transform=" translate(-255.54, -255.67)"
          d="M 163.53 21.28 C 159.268 21.322000000000003 155.12800000000001 22.598000000000003 151.594 25.062 C 136.98399999999998 35.25 129.85999999999999 66.56700000000001 162.624 95.032 C 161.75 117.887 204.41 122.02199999999999 187.469 88.375 C 202.844 43.657 182.004 21.105000000000004 163.529 21.281000000000006 z M 418.78 30.844 C 412.587 30.852 405.78299999999996 33.728 402 39.469 C 378.85 74.59100000000001 403.875 92.485 427.875 54.405 C 437.738 38.755 429.105 30.830000000000002 418.781 30.843 z M 377.063 94.31200000000001 C 313.643 151.19500000000002 266.033 232.747 129.375 175.25 C 147.953 228.742 122.607 246.34 98.062 251.53 C 89.216 245.426 80.559 237.337 72.688 227.25 L 53.406000000000006 202.53 L 56.031000000000006 233.78 C 61.165000000000006 295.345 83.607 340.834 120.813 370.156 C 158.02 399.478 208.959 412.376 270.063 412.376 C 365.451 412.376 451.83299999999997 351.471 483.626 264.376 L 488.96999999999997 249.71899999999997 L 473.56199999999995 251.90499999999997 C 468.222 252.66199999999998 464.02199999999993 252.44899999999998 460.74999999999994 251.62499999999997 L 492.43799999999993 191.46799999999996 C 478.1139999999999 197.60299999999995 463.0829999999999 205.06099999999995 448.46799999999996 211.71799999999996 C 450.198 198.39399999999995 454.21799999999996 181.57799999999997 461.188 161.43599999999998 L 471.5 131.56099999999998 L 446.594 151 C 421.131 170.87 393.754 194.613 366.81399999999996 214.25 C 357.866 196.388 359.188 160.175 377.06199999999995 94.312 z M 33.188 139.906 C 24.310000000000002 139.899 15.176000000000002 151.372 17.5 162.594 C 23.656 192.322 53.294 183.784 46.344 154.844 C 43.751000000000005 144.049 38.514 139.91 33.187 139.906 z M 434.531 184.812 C 428.318 208.94400000000002 426.856 227.846 430.595 242.656 C 433.168 252.84900000000002 438.853 261.361 447.15700000000004 266.156 C 451.247 268.516 455.737 269.959 460.53200000000004 270.62600000000003 C 430.63200000000006 291.329 387.01000000000005 277.23600000000005 407.00200000000007 223.90600000000003 C 321.8140000000001 338.55100000000004 233.29500000000007 350.242 204.84600000000006 263.03100000000006 C 190.23300000000006 349.66100000000006 99.51800000000006 330.49300000000005 79.09600000000006 260.6890000000001 C 101.10600000000007 278.9890000000001 126.39400000000006 287.5130000000001 149.75200000000007 282.9390000000001 C 165.40500000000006 279.8730000000001 179.72900000000007 270.5450000000001 190.00200000000007 255.5010000000001 C 195.99200000000008 246.73100000000008 200.62400000000008 236.0370000000001 203.81500000000005 223.5010000000001 C 216.82300000000006 245.2330000000001 231.81700000000006 259.3030000000001 248.62700000000007 266.5950000000001 C 271.5470000000001 276.5370000000001 296.35400000000004 273.2080000000001 320.31500000000005 263.37500000000006 C 359.5210000000001 247.28900000000004 398.672 214.23100000000005 434.5330000000001 184.81300000000005 z M 428.531 364.5 C 439.927 372.138 446.626 380.712 446.626 389.625 C 446.626 422.397 361.056 449.188 256.251 449.188 C 151.44699999999997 449.188 66.43799999999999 422.39799999999997 66.43799999999999 389.625 C 66.43799999999999 380.98 72.60799999999999 372.525 83.37599999999999 365.095 C 43.57599999999999 378.39300000000003 18.531999999999996 396.31500000000005 18.531999999999996 415.90500000000003 C 18.531999999999996 456.925 125.079 490.06300000000005 256.252 490.06300000000005 C 387.425 490.06300000000005 493.94 456.92600000000004 493.94 415.90600000000006 C 493.94 396.11300000000006 469.048 377.86800000000005 428.533 364.50000000000006 z"
          stroke-linecap="round"
        />
      </g>
    </svg>
  </div>
  <div class="sea">
    <div class="wave"></div>
    <div class="wave"></div>
  </div>
</div>
